import React, { Component } from 'react';
import PropTypes from 'prop-types';
import langIsEn from '../../utils/langIsEn';
import ReactResizeDetector from 'react-resize-detector';
import styles from './InfoSlogan.css';

class InfoSlogan extends Component {
  static propTypes = {
    onHeightCalculated: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.onHeightCalculated()
  }

  onResize() {
    this.onHeightCalculated()
  }

  onHeightCalculated() {
    const { onHeightCalculated } = this.props;
    onHeightCalculated(this.infoSlogan.clientHeight);
  }

  renderEng() {
    return (
      <section className="container" ref={(section) => { this.infoSlogan = section; }}>
        <div className="col--m-6of12">
          <h1 className={styles.slogan}>
            Five Metal Shop is an independent
            creative studio that helps our clients
            identify, understand
            and solve strategic problems
            through design.
          </h1>
        </div>
      </section>
    );
  }

  renderCht() {
    return (
      <section className="container" ref={(section) => { this.infoSlogan = section; }}>
        <div className="col--m-6of12">
          <h1 className={styles.sloganCht}>
            Five Metal Shop 是一個獨立品牌工程師，從事物的本質出發，是我們設計的原點。
          </h1>
        </div>
      </section>
    );
  }

  render() {
    return (
      <div>
        <ReactResizeDetector handleWidth handleHeight onResize={this.onResize.bind(this)} />
        {langIsEn() && this.renderEng()}
        {!langIsEn() && this.renderCht()}
      </div>
    );
  }
}

export default InfoSlogan;



// WEBPACK FOOTER //
// ./src/components/info-slogan/InfoSlogan.js